<template>
<div style="position: relative;">

	<loading-indicator :loading="isLoading"></loading-indicator>

	<template v-if="!isLoading">

		<!-- page-heading -->
		<page-heading show="false" showBack="false" pageTitle="HEADER-APOPOINT-CMS"></page-heading>

        <div class="col-main">

			<img src="@/assets/img/apopointCMS.jpg" />

            <div class="box">


				<p>
					Hier geht’s zu Ihrem persönlichen ApoPoint CMS.
				</p>
				<p>
					Dort können Sie alles rund um Ihre Webseite erledigen:
				</p>
				<ul>
					<li>Bestellungen verwalten</li>
					<li>Aktuelle Beiträge pflegen und erstellen</li>
					<li>Anpassen von Inhalten (Team, Beschreibung, Services, usw…)</li>
					<li>uvm.</li>
					<!--
					Aktuelle Beiträge pflegen und erstellen<br />
					Anpassen von Inhalten (Team, Beschreibung, Services, usw…)<br />
					uvm.
				-->
				</ul>
				<p>
					Der angeführt Link führt Sie zu Ihrem ApoPoint Backend-Modul, wo Sie sich mit Ihren User-Daten anmelden können.
				</p>

                <br />
                <custom-button type="blue" @click.native="goTo">Zum Login</custom-button>

            </div>

        </div>



	</template>
</div>




</div>
</template>


<script>


export default {


	data() {

		return {
			isLoading: true,
		}

	},

	created() {

		this.fetchData();

	},

	computed: {


	},

	methods: {

		fetchData() {

			this.isLoading = true;

            this.isLoading = false;

		},

        goTo() {

            let win = window.open(this.activeUser.site.apopointUrl + '/wp-admin/', '_blank');
            win.focus();

        }


	},

}
</script>





<style lang="scss" scoped>

	img {
		margin-bottom: 15px;
	}

	.box {
		p {
			margin-bottom: 1em;
		}
		ul {
			list-style-type: disc;
			padding-left: 20px;
			margin-bottom: 1em;
		}
	}
</style>
